<template>
  <div class="p-footer" :class="{'downpay': product.downPayment, 'downPayOriginSoldOut': downpayOriginSoldOut}">
    <div class="downpay-footer" v-if="product.downPayment" @click="downpayAction">
      <div class="downpay-desc">
        <div class="desc-main" v-if="downpayPrice">
          <div class="downpay-label">定金</div>
          <div class="downpay-price" v-if="downpayPrice.length > 1">
            <price :data="downpayPrice[0]"></price>
            <span v-if="!product.downPayment.priceSingle"> - <price :data="downpayPrice[1]"></price></span>
          </div>
          <div class="downpay-price" v-else>
            <price :data="downpayPrice[0]"></price>
          </div>
        </div>

        <div class="desc-sub" v-if="downpayDeduction && product.downPayment.deductionFlag">（ 可抵
          <div class="downpay-price" v-if="downpayDeduction.length > 1">
            <price :data="downpayDeduction[0]"></price>
            <span v-if="!product.downPayment.deductionSingle"> - <price :data="downpayDeduction[1]"></price></span>
          </div>
          <div class="downpay-price" v-else>
            <price :data="downpayDeduction[0]"></price>
          </div> ）
        </div>
      </div>
      <div class="arrow-text">立即预订</div>
      <div class="arrow"></div>
      <!-- <div class="action">
        <div class="earnest-tips">
          <div>
            <p>11.10 22:00定金支付结束</p>
            <p >11.11 01:00付尾款{{ getFinalPrice(product.downPayment.range) }}</p>
          </div>
        </div>
        <div class="earnest" @click="earnest">
          <div>
            <div class="pay-price">支付定金&yen;{{ product.downPayment.details[0].price }}</div><div class="price">（抵&yen;{{ product.downPayment.details[0].deduction }}）</div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="normal-footer">
      <div class="minicart" @click="toCart">
        <!-- <div class="fix-num" >
          <div class="cart-num">
            
          </div>
          <div class="triangle-right">
          </div>
        </div> -->
      </div>
      <div class="service" @click="toService"><i v-if="msgCount > 0"></i></div>
      <div class="wechat-gift-box" v-if="product.isWechatGift && !product.offShelf && !product.soldOut" @click="showWechatGiftBox">
        <img v-if="gifUrl" id="panda-gif" :src="gifUrl" @load="gifLoaded"/>
      </div>
      <div class="action" :class="no-buy" v-if="!app && (product.id === 'PROD001032623' || product.id === 'PROD001032622')">
        <!-- <open-app
          :cls="'open-btn'"
          :text="'去APP购买'"
          :link="openAppLink"
        /> -->

        <!-- <a :href="iosAul" class="btn dark" v-if="ios && !weixin">去APP购买</a> -->
        <a :href="iosAul" class="btn dark" v-if="ios" @click="iosDownloadApp">去APP购买</a>
        <div class="btn dark" v-if="android" @click="androidDownloadApp">去APP购买</div>
      </div>
      <div class="action booking" v-else-if="product.arrival && product.arrival.show">
        <div class="" v-if="!product.arrival.subscribe && !booked">
          <div class="texts" >
            <p>若想要人数较多,</p>
            <p>将有补货可能哦!</p>
          </div>
          <div class="btn" @click="bookProduct(product.id)">
            <p>我也想买</p>
            <p class="sm">(补货后提醒我)</p>
          </div>
        </div>
        <div class="" v-else>
          <div class="texts">
            <p>若补货成功会优先短信提醒你!</p>
            <p>若未补货,将不再另行通知!</p>
          </div>
          <div class="btn">
            <p class="booked">已登记</p>
          </div>
        </div>
      </div>
     
      <div class="action" :class="{ 'no-buy': unSale() }" v-else-if="!product.soldOut && product.customPrintTemplate == 6">
        <div class="btn btn-buy dark" @click="tapBuyCustom">立即定制</div>
      </div>
      <div class="action" :class="{ 'no-buy': unSale() }" v-else-if="!product.downPayment || (product.downPayment && !product.soldOut)">
        <div class="btn btn-buy" :class="{'small-btn': product.isWechatGift}" v-if="!product.prevue && !product.customizable" @click="tapBuy">立即购买</div>
        <div class="btn btn-cart dark" :class="{'small-btn': product.isWechatGift}" v-if="!product.customizable && !product.monthSend" @click="tapCart">加入购物车</div>
        <a :href="aul" class="btn dark" v-if="product.customizable">去APP购买</a>
      </div>
      <!-- <div class="action" v-else>
        <div class="earnest-tips">
          <div>
            <p>11.10 22:00定金支付结束</p>
            <p >11.11 01:00付尾款{{ getFinalPrice(product.downPayment.range) }}</p>
          </div>
        </div>
        <div class="earnest" @click="earnest">
          <div>
            <div class="pay-price">支付定金&yen;{{ product.downPayment.details[0].price }}</div><div class="price">（抵&yen;{{ product.downPayment.details[0].deduction }}）</div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import bridge from '@beastshop/bridge'
import browser from '@beastshop/browser'
import track from '@/track'
import {
  btoa
} from 'b2a'
import util from '../util'
import api from '../api'
import Price from '@/price/index'
import openApp from '@/components/open-app/index.vue'
 import { ensure_deeplink } from '@beastshop/iframe-deeplink'

let _rush_count_down = null

export default {
  props: ['product', 'suggestType', 'msgCount', 'env'],

  data () {
    return {
      djsformat: null,
      app: browser.app(),
      ios: browser.ios(),
      android: browser.android(),
      weixin: browser.weixin(),
      booked: false,
      downpayPrice: null,
      downpayDeduction: null,
      openAppLink: `product/${this.product.id}`, 
      gifUrl: '//img.thebeastshop.com/app/4.0/icon/gift/icon-panda-gif-v2.gif'
    }
  },

  components: {
    Price,
    openApp
  },

  computed: {
    aul: function() {
      const PROTOCOL = location.protocol
      const IOS_LINK = btoa(`${PROTOCOL}//a.app.qq.com/o/simple.jsp?pkgname=com.thebeastshop.thebeast`)
      const DEEP_LINK = btoa(`product/${this.product.id}`)
      return browser.ios() ?
        `${PROTOCOL}//${process.env.AUL_DOMAIN}/r?r=${IOS_LINK}&_d=${DEEP_LINK}` :
        `https://m.thebeastshop.com/dl?_d=${DEEP_LINK}`
    },

    iosAul: function() {
      const PROTOCOL = location.protocol
      const IOS_LINK = `${PROTOCOL}//a.app.qq.com/o/simple.jsp?pkgname=com.thebeastshop.thebeast`
      const TD_PREFIX = `${PROTOCOL}//lnk0.com/`
      // const iosTD = '10UtQd'
      const iosTD = 'BRhIds'
      const il = iosTD?`${TD_PREFIX}${iosTD}`:IOS_LINK
      const iLink = btoa(il)
      const DEEP_LINK = btoa(`product/${this.product.id}`)
      return `${PROTOCOL}//${process.env.AUL_DOMAIN}/r?r=${iLink}&_d=${DEEP_LINK}`
    },

    downpayOriginSoldOut () {
      return (this.product.downPayment && this.product.soldOut) ? true : false //普通商品正常显示，定金商品时普通商品售罄隐藏
    }
  },

  created () {
    this.formatDownpayData()
  },

  mounted () {
    // let timer = setInterval(() => {
    //   this.gifUrl = ''
    //   this.$nextTick(() => {
    //     this.gifUrl = `//img.thebeastshop.com/app/4.0/icon/gift/icon-panda-gif-v2.gif?t=${new Date().getTime()}`
    //   })
    //   // clearInterval(timer)
    //   // timer = null
    // },2500)
  },

  inject: ['toggleQXLpBox'],
  
  methods: {
    gifLoaded () {
      let timer = setInterval(() => {
        this.gifUrl = ''
        this.$nextTick(() => {
          this.gifUrl = `//img.thebeastshop.com/app/4.0/icon/gift/icon-panda-gif-v2.gif?t=${new Date().getTime()}`
        })
        clearInterval(timer)
        timer = null
      },2500)
    },

    iosDownloadApp () {
      this.$emit('showMask')
      return
    },

    androidDownloadApp () {
      if (this.env === 'wx-web' && this.android) {
        this.$emit('showMask')
        return
      }

      const deepUrl = `beastapp://product/${this.product.id}`
      ensure_deeplink(deepUrl)

      const PROTOCOL = location.protocol
      const TD_PREFIX = `${PROTOCOL}//lnk0.com/`
      const androidTD = 'xJFBxt'
      const ANDROID_LINK = `${PROTOCOL}//static.thebeastshop.com/app/beast.apk`
      let redirectLink = androidTD?`${TD_PREFIX}${androidTD}`:ANDROID_LINK
      window.location.href = redirectLink
    },

    formatDownpayData () {
      const downpayPrice = []
      const downpayDeduction = []
      if(!this.product.downPayment) {
        return
      }
      const details = this.product.downPayment.details
      if(details.length > 1) {
        const downpayData = details.sort(this.downpaySort)
        downpayPrice.push(downpayData[0].price)
        downpayPrice.push(downpayData[downpayData.length-1].price)

        downpayDeduction.push(downpayData[0].deduction)
        downpayDeduction.push(downpayData[downpayData.length-1].deduction)
      } else {
        downpayPrice.push(details[0].price)
        downpayDeduction.push(details[0].deduction)
      }
      
      this.downpayPrice = downpayPrice
      this.downpayDeduction = downpayDeduction

      console.log(this.downpayPrice, this.downpayDeduction)
    },

    showWechatGiftBox () {
      this.$emit('showWechatGift')
    },

    bookProduct (pid) {
      this.$ensureLogged({
        event: '补货提醒'
      })
      .then(() => {
        this.arrival(pid)

        sa.track('ApplyCommodity', {
          ...sa.getReferPageName(),
          commodity_spu_id: pid,
          commodity_name: this.product.name,
          activity_type: sa.getActivity(this.product.labels),
          original_price: this.product.rawPrice,
          discount_price: this.product.price
        })
      })
      .catch(err => {
        
      })
    },

    arrival (pid) {
      this.$showLoading()
      api.doArrival(pid)
      .then(({data}) => {
        this.$hideLoading()
        this.$toast('登记成功，若补货成功会优先短信提醒你！')
        this.booked = true
      })
      .catch(err => {
        this.$hideLoading()
        this.$toast(err.message || '未知错误')
      })
    },

    toCart () {
      if (browser.app()) {
        bridge.open({
          url: 'beastapp://cart'
        })
      } else {
        window.location.href = '/cart'
      }
    }, 

    toService () {
      if ( browser.app()) {
        bridge.open({
          url: 'beastapp://entry?name=customer-service'
        })
      } else {
        this.$emit('openService')
      }
    },

    tapBuyCustom () {
      this.$ensureLogged()
      .then((status) => {
        this.checkBuy()
        .then(spv => {
          api.orderPreview(spv.id, spv.count, this.product.orderType)
          .then(({
            code,
            data
          }) => {
            this.toggleQXLpBox(spv.id, spv.count, data.orderType, data)
          })
          .catch(({
            code
          }) => {
            if (code == '4001') {
              this.$verifiedMobile()
              .then(() => {})
              .catch(() => {})
            }
          })
        })
      })
    },

    tapBuy: function(type) {
      if (this.unSale()) {
        return false
      }

      track({
        name: 'buy',
        attrs: {
          suggestType: this.suggestType
        }
      })

      this.$ensureLogged({
        event: '立即购买'
      })
      .then((status) => {
        if (this.product.monthSend) {
          window.location.href = `/week/flower?productId=${this.product.id}&distType=${this.product.monthSendDistType}`
          return
        }
        this.checkBuy()
        .then((data) => {
          // 神策
          const _ck_spv = data.spv
          sa.buyNow({
            ...sa.getReferPageName(),
            commodity_spu_id: this.product.id,
            commodity_spv_id: data.id,
            commodity_name: this.product.name,
            activity_type: sa.getActivity(this.product.labels),
            commodity_number: data.count,
            original_price: _ck_spv.rawPrice,
            discount_price: _ck_spv.price,
            commodity_need_point: _ck_spv.point
          })

          let _orderType = this.product.furniture ? 'FURNITURE' : 'NORMAL'
          if (type === 'wechat-gift') {
            _orderType = 'WECHAT_GIFT'
          }

          api.orderPreview(data.id, data.count, _orderType)
          .then(({
            code,
            data
          }) => {
            sa.track('commodity_account')
            if (browser.app()) {
              bridge.open({
                url: 'beastapp://order',
                data: data
              })
            }else{
              sessionStorage.orderData = JSON.stringify(data)
              window.location.href = "/order"
            }
          })
          .catch(({
            code,
            message
          }) => {
            if (code == '4001') {
              this.$verifiedMobile()
              .then(() => {})
              .catch(() => {})
            }

            this.$toast(message || '系统未知错误')
          })
        })
      })
      .catch(() => {
        //
      })
    },

    tapCart () {
      if (this.unSale()) {
        return false
      }

      track({
        name: 'addCart',
        attrs: {
          suggestType: this.suggestType
        }
      })

      this.checkBuy()
      .then((data) => {
        if (data === null) {
          return false
        }

        const _ck_spv = data.spv

        sa.addCart({
          ...sa.getReferPageName(),
          commodity_spu_id: this.product.id,
          commodity_spv_id: data.id,
          commodity_name: this.product.name,
          activity_type: sa.getActivity(this.product.labels),
          commodity_number: data.count,
          original_price: _ck_spv.rawPrice,
          discount_price: _ck_spv.price,
          commodity_need_point: _ck_spv.point || 0
        })

        api.addCart(data.id, data.count)
        .then(({
          code,
          data
        }) => {
          this.$toast('加入购物车成功')
          // this.broadcast('cart-change')
          api.getCartNum()
          .then(({
            data
          }) => {
            this.cart_num = data || 0
          })
        })
        .catch(err => {
          this.$toast(err.message || `系统未知错误，错误码${err.code}`)
        })
      })
      .catch(() => {

      })
    },

    //   -----------   定金代码， 待优化  ------------------//
    downpayAction () {
      this.$ensureLogged()
      .then(() => {
        let _variant = this.product.variant
        const downSpvs = this.product.downPayment.details
        let downFlag = false
        downSpvs.forEach(dp => {//判断是不是全部没库存
          if(dp.stock) {
            downFlag = true
          }
        })
        if(!downFlag) {
          this.$alert('预售机会已抢空')
          return
        }

        if ((_variant.dimensions && _variant.dimensions.length > 0) || (_variant.spvs.length == 1 && _variant.spvs[0].minAmount > 1)) {
          let product = util.get_variant_data(this.product)
          // product.selectAmount = false

          let newProduct = util.deepCopy(product)
          const newSpvs = []
          if(this.product.downPayment) {
            const newVariant = newProduct.variant
            const spvs = newVariant.spvs
            spvs.forEach((sp, index) => {
              downSpvs.forEach((dp, i) => {
                if(sp.id == dp.spvId) {
                  let spv = newProduct.variant.spvs[index]
                  spv.left = downSpvs[i].stock
                  spv.price = downSpvs[i].price
                  newSpvs.push(spv)
                  // newProduct.variant.spvs[index].left = downSpvs[i].stock
                  // newProduct.variant.spvs[index].price = downSpvs[i].price
                }
              })
            })
          }
          newProduct.variant.spvs = newSpvs
          // console.log(newProduct, 'newProduct')
          
          this.$selectVariant(newProduct)
          .then((data) => {
            if (data === null) {
              return
            }
            // return

            const downPayment = this.product.downPayment
            let _spv = downPayment.details.find((spv) => {
              return spv.spvId == data.spvId
            })

            if(_spv.stock === 0){
              this.$alert('商品已售罄')
              return
            }
            const spv = {
              id: _spv.virtual,
              count: data.count
            }
            this.downpayOrder(spv)
          })
        } else {
          const _spv = this.product.downPayment.details[0]
          if(_spv.stock === 0){
            this.$alert('商品已售罄')
            return
          }
          this.downpayOrder({
            id: _spv.virtual,
            count: 1
          })
        }
      })
      .catch(() => {})
    },

    downpayOrder (pack) {
      this.$showLoading()
      api.orderPreview(pack.id, pack.count, 'DEPOSIT')
      .then(({
        code,
        data
      }) => {
        data.orderType = 'DEPOSIT'
        this.$hideLoading()
        if (browser.app()) {
            bridge.open({
            url: 'beastapp://order',
            data: data
          })
        } else {
          sessionStorage.orderData = JSON.stringify(data)
          window.location.href = "/order"
        }
      })
      .catch(({
        code,
        message
      }) => {
        this.$hideLoading()
        if (code == '4001') {
          this.$verifiedMobile()
          .then(() => {})
          .catch(() => {})
        } else {
          this.$alert(message)
        }
      })
    },

    getFinalPrice (range){
      if (range.length === 2) {
        return `¥${range[0]}-¥${range[1]}`
      } else {
        return `¥${range[0]}`
      }
    },

    checkBuy () {
      let _variant = this.product.variant

      return new Promise((resolve, reject) => {
        this.checkUnavailable()
        .then(() => {
          if (true || (_variant.dimensions && _variant.dimensions.length > 0) || (_variant.spvs.length == 1 && _variant.spvs[0].minAmount > 1)) {
            let product = util.get_variant_data(this.product)
            // console.log(product)
            this.$selectVariant(product)
            .then((data) => {
              if (data === null) {
                return reject()
              }
              resolve({
                id: data.spvId,
                count: data.count,
                spv: data
              })
              this.selectSpv(data.spvId)
            })
          } else {
            resolve({
              id: this.product.variant.spvs[0].id,
              count: 1
            })
          }
        })
        .catch(() => {
          reject()
        })
      })
    },

    selectSpv (spvId) {
      let _spv = this.product.variant.spvs.find((spv) => {
        return spv.id == spvId
      })

      let fundPrice = []

      if (_spv.refunds) {
        fundPrice.push(_spv.refunds)
      }

      this.product._rush = {
        state: _spv.flashSale ? !_spv.flashSale.soldOut : false,
        notAll: false,
        flashSale: _spv.flashSale ? _spv.flashSale : null,
        _djs: _spv.flashSale ? _spv.flashSale.expiresAt : null
      }

      this.product.format_price = {
        price: {
          min: _spv.price
        },
        rawPrice: {
          min: _spv.rawPrice
        }
      }

      this.product.spvPriceTag = _spv.priceTags
      this.product.spvPriceInfo = _spv.priceInfo

      this.$emit('change', fundPrice)
      this.djsformat = null
      clearTimeout(_rush_count_down)
      this.product._rush._djs && getCountDown()
    },

    checkUnavailable: function() {
      if (this.product.needVerifyAddress && !(!this.product.unavailable && this.product._address)) {}
      return new Promise((resolve, reject) => {
        return resolve()
        if (this.product.needVerifyAddress &&
          !(!this.product.unavailable && this.product._address)) {
          this.$alert('请选择配送区域')
          .then(() => {
            return this.$selectArea()
          })
          .then((data) => {
            if (data === null) {
              return reject()
            }
            this.product._address = `${data.province.name} ${data.city.name} ${data.district.name}` // resolve()
            return api.isDistribution(this.product.id, data.district.id)
          })
          .then(({
            data
          }) => {
            this.product.unavailable = !data
            return data ? resolve() : reject()
          })
          .catch(() => {
            return reject()
          })
        } else {
          return resolve()
        }
      })
    },

    getCountDown () {
      let endDate = new Date(this.product._rush._djs),
          _now = new Date()

      let leftTime = endDate.getTime() / 1000 - _now.getTime() / 1000,
        leftsecond = parseInt(leftTime),
        day1 = Math.floor(leftsecond / (60 * 60 * 24)),
        hour = Math.floor((leftsecond - day1 * 24 * 60 * 60) / 3600),
        minute = Math.floor((leftsecond - day1 * 24 * 60 * 60 - hour * 3600) / 60),
        second = Math.floor(leftsecond - day1 * 24 * 60 * 60 - hour * 3600 - minute * 60)
      hour += day1 * 24
      if (hour == 0 && minute == 0 && second == 0) {
        this.djsformat = null
        clearTimeout(_rush_count_down)
        return false
      }
      this.djsformat = `${hour}:${minute}:${second}`
      _rush_count_down = setTimeout(() => {
        this.getCountDown()
      }, 1000);
    },

    unSale () {
      const _product = this.product
      return _product.soldOut ||
        !_product.buyable ||
        _product.offShelf ||
        (!_product.invisible && !_product.buyable)
    },

    downpaySort (prev, next) {
      return prev.price - next.price
    }
  }
}
</script>

<style lang="stylus">
</style>





// WEBPACK FOOTER //
// footer.vue?040dbf15